/**
 * @license EUPL-1.2
 * Copyright (c) 2020-2024 Frameless B.V.
 * Copyright (c) 2021-2024 Gemeente Utrecht
 */

import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-progress-list',
  styleUrl: 'progress-list.scss',
  shadow: true,
})
export class StepProgressList {
  render() {
    return (
      <ol class="denhaag-process-steps">
        <slot></slot>
      </ol>
    );
  }
}
